<template>
  <v-sheet
    :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
    style="box-shadow: 0px 0px 20px 0px #0000000d"
    class="pa-3 rounded-lg">
    <v-card-title class="d-flex justify-space-between pa-0">
      <span class="font-weight-bold" style="color: var(--v-grey-500-base)">{{ title }}</span>
    </v-card-title>
    <v-sheet
      :color="'transparent'"
      :height="canvasHeight"
      class="d-flex justify-center align-center">
      <canvas
        id="flowChart"
        style="width: 100%; max-width: 100%; height: auto; padding: 10px"></canvas>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { Chart } from 'chart.js';
  export default {
    name: 'FlowChart',
    data() {
      return {
        chart: null,
      };
    },
    props: {
      title: String,
      canvasHeight: String,
      chartData: {
        type: Array,
        default: () => [],
      },
    },
    mounted() {
      const ctx = document.getElementById('flowChart').getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: [
            '12 AM',
            '2 AM',
            '4 AM',
            '6 AM',
            '8 AM',
            '10 AM',
            '12 PM',
            '2 PM',
            '4 PM',
            '6 PM',
            '8 PM',
            '10 PM',
          ],
          datasets: [
            {
              backgroundColor: '#759745',
              data: this.chartData,
              barThickness: 15,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              position: 'top',
              min: 0,
              max: 900,
              ticks: {
                stepSize: 100,
                callback: function (value) {
                  const labels = [0, 100, 200, 300, 400, 500, 600, 700, 800, 900];
                  return labels.includes(value) ? value : '';
                },
              },
            },
            y: {
              beginAtZero: true,
              reverse: true,
              ticks: {
                stepSize: 1,
              },
            },
          },
        },
      });
    },
    watch: {
      chartData: {
        handler: function (val) {
          this.chart.data.datasets[0].data = val;
          this.chart.update();
        },
        deep: true,
      },
    },
  };
</script>

<style scoped>
  canvas {
    max-width: 100%;
  }
</style>
